<template>
  <div
    id="createSellerAccount"
    class="container"
  >
    <section class="steps">
      <Steps />
    </section>
    <section class="formContainer">
      <Step1 ref="step1" />
    </section>
  </div>
</template>

<script>
import Steps from '_c/steps'
import Step1 from '_c/create-seller-account/step1'
export default {
  components: {
    Steps,
    Step1
  },
  mounted() {
    this.handleOAuthCallback()
  },
  methods: {
    async handleOAuthCallback() {
      if (sessionStorage.getItem('oauth_flow_enabled') !== '1') {
        return
      }
      const { code, state } = this.$route.query
      if (!code && !state) {
        return
      }
      if (!code || !state) {
        this.$Message.error(this.$t('createSellerAccount.entry.oauthCodeMissing'))
        return
      }
      const loginType = this.$route.query.loginType
      if (loginType) {
        sessionStorage.setItem('oauth_login_type', loginType)
      } else {
        sessionStorage.removeItem('oauth_login_type')
      }
      try {
        const response = await this.$axios.get('/oauth2/seller-info', {
          params: {
            code,
            state,
            platform: 'kilimall'
          },
          validateStatus: () => true
        })
        if (response.status !== 200 || Number(response.data.code) !== 0) {
          const cached = sessionStorage.getItem('oauth_seller_info')
          if (!cached) {
            this.$router.replace('/create-seller-account/entry')
            return
          }
          this.refreshSellerInfo()
          return
        }
        sessionStorage.setItem(
          'oauth_seller_info',
          JSON.stringify(response.data.data || {})
        )
        if (response.data.data && response.data.data.tokenExpiresAt) {
          sessionStorage.setItem(
            'oauth_seller_info_expire_at',
            String(response.data.data.tokenExpiresAt)
          )
        }
        this.refreshSellerInfo()
        console.log('oauth2 seller info:', response.data)
      } catch (error) {
        console.error('oauth2 seller info error:', error)
        this.$router.replace('/create-seller-account/entry')
      }
    },
    refreshSellerInfo() {
      if (this.$refs.step1 && this.$refs.step1.loadSellerInfo) {
        this.$refs.step1.loadSellerInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#createSellerAccount {
  .steps {
    margin: 0.3rem 0;
  }
  .formContainer {
    margin: 0.5rem auto;
    // width: 4rem;
    padding: 0 290px;
  }
}
</style>
